import { getQueryofKey, getQueryString } from '../../utils/getUrlParams'
import urlExt from '../../node_modules/@imp/package/lib/zyb-yike-utils/urlExt'
import { encode } from 'js-base64'
import md5 from 'blueimp-md5'
import qs from 'qs'
// 当前链接
const pageUrl = window.location.href
// 获取当前链接上的所有参数
const urlParams: any = urlExt.getQuery()
const lastfrom: string = urlParams['lastfrom']

// 不同的渠道对应的clickId名称
export const channelClickIdConfig: any = {
  pyq: 'gdt_vid',
  gdt: 'qz_gdt',
  jrtt: 'clickid',
  bd: 'bd_vid',
  bdxxl: 'bd_vid',
  oppo: 'tid',
  kuaishou: 'callback',
  xiaomi: 'logExtra',
  xlwb: 'mark_id',
  sm: 'clickid',
  jd: 'jduid',
  tuia: 'a_oId',
  sg: 'sg_vid',
  huawei: 'callback',
  krw: 'callback',
  uc: 'url', // 完整url
  xmla: 'callback', // 喜马拉雅渠道(命名为xmla是历史原因)
  bcjh: 'bc_tag',
  bxm: 'bxm_id',
  cat: 'bxm_id',
  xhs: 'trackId',
  wyyd: 'ext_youdao',
}

// 端外获取clickId方法
export async function getClickId() {
  const channel = getChannel()
  //clickId 通用逻辑
  let clickId: any = channelClickIdConfig[channel]
    ? urlParams[channelClickIdConfig[channel]]
    : ''
  // 各渠道clickId特殊处理逻辑
  // UC
  if (channel === 'uc') {
    clickId = encode(pageUrl)
  }
  // 广点通渠道，如果没有取到渠道标识的值，则取朋友圈的信息
  if (channel === 'gdt') {
    if (!clickId) {
      clickId = urlParams[channelClickIdConfig['pyq']]
    }
  }
  // 朋友圈渠道，如果没有取到渠道标识的值，则取广点通的信息
  if (channel === 'pyq') {
    if (!clickId) {
      clickId = urlParams[channelClickIdConfig['gdt']]
    }
  }
  if (channel === 'xmla') {
    // clickId = encode(clickId)
    console.log('get-clickId:xmla', clickId)
  }
  // 快手渠道，快手的关键参数比较长，需要调用后端接口去换一个短信息作为clickId传递
  if (channel === 'kuaishou') {
    // 超过400才处理
    if (clickId && clickId.length > 400) {
      const originClickId = clickId
      // 前端生成短链，后端也会生成，这里是调接口去上传存在redis，没有存成功的话，也可以通过解密补充上报
      pollingTimesKuaiClickId(originClickId)
      clickId = 'zybqdclickid_' + md5(clickId)
    }
  }
  const appId = urlParams['appId'] || urlParams['appid']
  // 如果链接上存在appId则认为是投放公众号渠道
  if (appId) {
    console.log('公众号投放，获取到appId')
    clickId = await pollingTimesGetOpenId(appId)
  }
  return clickId || ''
}

// 从lastfrom获取当前投放渠道
export function getChannel() {
  if (lastfrom) {
    return (
      (Array.isArray(lastfrom)
        ? lastfrom[0].split('_')[2]
        : lastfrom.split('_')[2]) || ''
    )
  } else {
    return ''
  }
}

// 从后端获取替换的短clickId
async function getKuaiShouClickId(params: any) {
  const newParams = {
    clickIds: JSON.stringify(params),
  }
  const res = await (<any>window).$axios.post(
    `/qudao/api/clickids`,
    qs.stringify(newParams)
  )
  return res.data || null
}

async function getOpenId(appId: any) {
  console.log('getOpenId', appId)
  console.log('(<any>window).$axios', (<any>window).$axios)
  const res = await (<any>window).$axios.get(`/qudao/api/getwxauthstatus`, {
    params: {
      appid: appId,
    },
  })
  return res.data || null
}

// 3次轮询方法openId
async function pollingTimesGetOpenId(appId: any) {
  console.log('pollingTimesGetOpenId', appId)
  let openId = ''
  for (let i = 0; i < 3; i++) {
    const res = await getOpenId(appId)
    console.log('getOpenId-res', res)
    if (
      res &&
      res.errNo === 0 &&
      res.data.isOpenid &&
      Number(res.data.isOpenid) === 1
    ) {
      openId = res.data.openId
      break
    }
  }
}

// 3次轮询方法快手clickId
async function pollingTimesKuaiClickId(param: any) {
  let urlParams = [
    {
      lastfrom,
      clickId: param,
      hash: 'zybqdclickid_' + md5(param),
    },
  ]
  for (let i = 0; i < 3; i++) {
    const res = await getKuaiShouClickId(urlParams)
    if (res.data[0].result == 1) {
      break
    }
  }
}
